import {
	useEffect,
	useState,
	useCallback,
	useContext,
	createContext
} from 'react'

import { useRouter } from 'next/router'

import { useUser } from './UserProvider'

import { useFeatureFlags } from 'hooks'

import { getCouponValue } from 'services/coupons'

import { getDataContractId } from 'utils/helpers'

const CouponContext = createContext(null)

const COUPON_STORAGE_KEY = '@vittude:promoCoupon'
const COUPON = 'PRIMEIRACONSULTA'

const CouponProvider = ({ children }) => {
	const [coupon, setCoupon] = useState(null)
	const [isUserB2B, setIsUserB2B] = useState(false)
	const [isFirstConsultation, setIsFirstConsultation] = useState(false)
	const [isCheckoutValidToApplyCoupon, setIsCheckoutValidToApplyCoupon] =
		useState(false)

	const { isUserLoggedIn, user } = useUser()

	const { pathname } = useRouter()
	const { frontend_is_accessible_consultation_banner_visible } =
		useFeatureFlags('frontend_is_accessible_consultation_banner_visible')

	const dataContractId = getDataContractId()

	const fetchCoupon = useCallback(async () => {
		try {
			const storagedCoupon = localStorage.getItem(COUPON_STORAGE_KEY)

			if (storagedCoupon) {
				setCoupon(JSON.parse(storagedCoupon))
				return
			}

			const res = await getCouponValue({ coupon: COUPON })

			if (res?.data) {
				setCoupon(res.data)
				localStorage.setItem(COUPON_STORAGE_KEY, JSON.stringify(res.data))
			}
		} catch (error) {
			console.error('Erro ao buscar ou armazenar cupom:', error)
			localStorage.removeItem(COUPON_STORAGE_KEY)
		}
	}, [])

	useEffect(() => {
		fetchCoupon()
	}, [fetchCoupon])

	useEffect(() => {
		if (isUserLoggedIn) {
			if (user?.id && user?.role === 'patient') {
				if (user?.contract !== null) {
					setIsUserB2B(true)
				}

				if (user?.is_first_appointment) {
					setIsFirstConsultation(user?.is_first_appointment)
				}
			}
		} else if (dataContractId) {
			setIsUserB2B(true)
		} else {
			setIsUserB2B(false)
			setIsFirstConsultation(true)
		}
	}, [pathname, user, isUserLoggedIn, dataContractId])

	useEffect(() => {
		if (
			pathname === '/agendar-consultas/finalizar-pagamento' &&
			isFirstConsultation &&
			!isUserB2B &&
			frontend_is_accessible_consultation_banner_visible
		) {
			setIsCheckoutValidToApplyCoupon(true)
		} else {
			setIsCheckoutValidToApplyCoupon(false)
		}
	}, [pathname, isFirstConsultation, isUserB2B, isCheckoutValidToApplyCoupon])

	return (
		<CouponContext.Provider
			value={{
				coupon,
				isFirstConsultation,
				isUserB2B,
				isCheckoutValidToApplyCoupon
			}}
		>
			{children}
		</CouponContext.Provider>
	)
}

const useCoupon = () => {
	const context = useContext(CouponContext)
	if (!context) {
		throw new Error('useCoupon must be used within a CouponProvider')
	}
	return context
}

export { CouponProvider, useCoupon }
